import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzTitleWebComponent } from '../../gzTitle';
import { LineHeights } from '../../../types/common/types';

export class GzTextWebComponent extends GzTitleWebComponent {
  /**
   *  The default line-height for text is Normal (1.5)
   */
  @property({ type: String, attribute: true, reflect: true })
  lineHeight = LineHeights.NORMAL;

  /**
   * By default, we expose the text using ::part(highlightable), so
   * any parent component can alter the styles of the text when hover
   * behaviour is required, for example see gz-basic-table.
   *
   * Setting this to true will not expose the part anymore.
   */
  @property({ type: Boolean, attribute: true, reflect: true })
  noHighlight = false;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html` <p part="text ${this.noHighlight ? '' : 'highlightable'}"><slot></slot></p> `;
  }
}
